import { ICardResponse } from "../../../services/api/banking/cards/types";

export const selectorWalletCards = (cards: ICardResponse[]): ICardResponse[] =>
  cards.filter(card => card.status !== "Closed");
